// extracted by mini-css-extract-plugin
var _1 = "DocFlowFile-modulefile__gQye3";
export { _1 as "file" }
